import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Card, CardBody, Row, Col, Spinner, Badge, Button } from "reactstrap";
import axiosInstance from "pages/Utility/axiosInstance";
import Breadcrumb from "components/Common/Breadcrumb2";
import { formatDateTimeToAmPm, formatISOToDDMMYYYY } from "helpers/dateFormat_helper";
import { FadeLoader } from "react-spinners";

const TutorProfile = () => {
  const { id } = useParams();
  const [tutor, setTutor] = useState(null);
  const [loading, setLoading] = useState(true);
 const defaultAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
  useEffect(() => {
    const fetchTutorProfile = async () => {
      try {
        const res = await axiosInstance.get(`V1/tutors/tutor-profile/${id}`);
        setTutor(res.data.data);
      } catch (error) {
        console.error("Failed to fetch tutor profile:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTutorProfile();
  }, [id]);

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
      >
        <FadeLoader color="#00a895" size={50} />
      </div>
    );

  if (!tutor)
    return (
      <div className="text-center mt-5">
        <h5>No Tutor Found</h5>
      </div>
    );

  return (
    <div className="page-content container-fluid">
      <div className="d-flex justify-content-between align-items-center mx-3 mb-4">
        <Breadcrumb
          title="Tutor Profile"
          breadcrumbItems={[
            { title: "Dashboard", link: "/dashboard" },
            { title: "Tutors", link: "/tutors" },
            { title: tutor.name, link: "#" },
          ]}
        />
        <Link to="/tutors">
          <Button color="secondary">Back</Button>
        </Link>
      </div>

      <Card className="shadow-sm">
        <CardBody>
          <Row>
            {/* Left Section — Profile Image */}
            <Col md="3" className="text-center border-end">
              <img
                src={tutor.profile_image || defaultAvatar}  
                alt={tutor.name}
                className="rounded-circle border mb-3"
                style={{ width: "150px", height: "150px", objectFit: "cover" }}
              />
              <h5 className="fw-bold">{tutor.name}</h5>
              <p className="text-muted mb-1">{tutor.email}</p>
              <p className="mb-2">{tutor.phone}</p>
              <Badge color={tutor.status ? "success" : "danger"}>
                {tutor.status ? "Active" : "Inactive"}
              </Badge>
            </Col>

            {/* Right Section — Details */}
            <Col md="9">
              <Row>
                <Col md="6" className="mb-3">
                  <strong>Role:</strong> <span>{tutor.role}</span>
                </Col>
                <Col md="6" className="mb-3">
                  <strong>Created At:</strong>{" "}
                  <span>{formatISOToDDMMYYYY(tutor.createdAt)}</span>
                </Col>
              </Row>

              {/* Assigned Courses */}
              <h6 className="mt-4 mb-3 fw-bold">Assigned Courses</h6>
              {tutor.courses?.length > 0 ? (
                <div className="row">
                  {tutor.courses.map((course) => (
                    <div key={course.id} className="col-md-6 col-lg-4 mb-3">
                      <div
                        className="p-3 border rounded-3 shadow-sm h-100 bg-light"
                        style={{
                          transition: "all 0.3s ease",
                          borderLeft: "4px solid #007bff",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "translateY(-3px)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "translateY(0)")
                        }
                      >
                        <h6
                          className="fw-semibold mb-2 text-primary"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={course.title}
                        >
                          {course.title}
                        </h6>

                        <p
                          className="text-muted mb-0"
                          style={{
                            fontSize: "0.9rem",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                          title={course.description}
                        >
                          {course.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-muted">No courses assigned.</p>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
};

export default TutorProfile;
